import { gql } from "@apollo/client";

export const LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMA_FIELDS = gql`
  fragment LanguageRepresentativeEducatorDiplomaFields on LanguageRepresentativeEducatorDiploma {
    id
    firstname
    lastname
    date
    place
    leader1 {
      id
      name
      firstname
      lastname
      email
      type
    }
    leader2 {
      id
      name
      firstname
      lastname
      email
      type
    }
    author {
      id
      name
      type
    }
    done
    created_at
    updated_at
    course_moment {
      id
      title
      type
      start_date
      end_date
      participants {
        id
        firstname
        lastname
      }
    }
    uid {
      id
      code
      created_at
    }
  }
`;

export const GET_LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMA = gql`
  query LanguageRepresentativeEducatorDiploma($id: ID!) {
    certLanguageRepresentativeEducatorDiploma(id: $id) {
      ...LanguageRepresentativeEducatorDiplomaFields
    }
  }
  ${LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMA_FIELDS}
`;

export const GET_LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMAS = gql`
  query LanguageRepresentativeEducatorDiplomas(
    $search: String
    $page: Int
    $limit: Int
    $orderBy: [GetLanguageRepresentativeEducatorDiplomasOrderByClause]
  ) {
    certLanguageRepresentativeEducatorDiplomas(
      search: $search
      page: $page
      limit: $limit
      orderBy: $orderBy
    ) {
      paginatorInfo {
        total
        currentPage
        hasMorePages
      }
      data {
        ...LanguageRepresentativeEducatorDiplomaFields
      }
    }
  }
  ${LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMA_FIELDS}
`;
